(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };

  // node_modules/ftdomdelegate/main.js
  function Delegate(root) {
    this.listenerMap = [{}, {}];
    if (root) {
      this.root(root);
    }
    this.handle = Delegate.prototype.handle.bind(this);
    this._removedListeners = [];
  }
  Delegate.prototype.root = function(root) {
    const listenerMap = this.listenerMap;
    let eventType;
    if (this.rootElement) {
      for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, true);
        }
      }
      for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, false);
        }
      }
    }
    if (!root || !root.addEventListener) {
      if (this.rootElement) {
        delete this.rootElement;
      }
      return this;
    }
    this.rootElement = root;
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, false);
      }
    }
    return this;
  };
  Delegate.prototype.captureForType = function(eventType) {
    return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType) !== -1;
  };
  Delegate.prototype.on = function(eventType, selector, handler, useCapture) {
    let root;
    let listenerMap;
    let matcher;
    let matcherParam;
    if (!eventType) {
      throw new TypeError("Invalid event type: " + eventType);
    }
    if (typeof selector === "function") {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      useCapture = this.captureForType(eventType);
    }
    if (typeof handler !== "function") {
      throw new TypeError("Handler must be a type of Function");
    }
    root = this.rootElement;
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!listenerMap[eventType]) {
      if (root) {
        root.addEventListener(eventType, this.handle, useCapture);
      }
      listenerMap[eventType] = [];
    }
    if (!selector) {
      matcherParam = null;
      matcher = matchesRoot.bind(this);
    } else if (/^[a-z]+$/i.test(selector)) {
      matcherParam = selector;
      matcher = matchesTag;
    } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
      matcherParam = selector.slice(1);
      matcher = matchesId;
    } else {
      matcherParam = selector;
      matcher = Element.prototype.matches;
    }
    listenerMap[eventType].push({
      selector,
      handler,
      matcher,
      matcherParam
    });
    return this;
  };
  Delegate.prototype.off = function(eventType, selector, handler, useCapture) {
    let i;
    let listener;
    let listenerMap;
    let listenerList;
    let singleEventType;
    if (typeof selector === "function") {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      this.off(eventType, selector, handler, true);
      this.off(eventType, selector, handler, false);
      return this;
    }
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!eventType) {
      for (singleEventType in listenerMap) {
        if (listenerMap.hasOwnProperty(singleEventType)) {
          this.off(singleEventType, selector, handler);
        }
      }
      return this;
    }
    listenerList = listenerMap[eventType];
    if (!listenerList || !listenerList.length) {
      return this;
    }
    for (i = listenerList.length - 1; i >= 0; i--) {
      listener = listenerList[i];
      if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
        this._removedListeners.push(listener);
        listenerList.splice(i, 1);
      }
    }
    if (!listenerList.length) {
      delete listenerMap[eventType];
      if (this.rootElement) {
        this.rootElement.removeEventListener(eventType, this.handle, useCapture);
      }
    }
    return this;
  };
  Delegate.prototype.handle = function(event) {
    let i;
    let l;
    const type = event.type;
    let root;
    let phase;
    let listener;
    let returned;
    let listenerList = [];
    let target;
    const eventIgnore = "ftLabsDelegateIgnore";
    if (event[eventIgnore] === true) {
      return;
    }
    target = event.target;
    if (target.nodeType === 3) {
      target = target.parentNode;
    }
    if (target.correspondingUseElement) {
      target = target.correspondingUseElement;
    }
    root = this.rootElement;
    phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
    switch (phase) {
      case 1:
        listenerList = this.listenerMap[1][type];
        break;
      case 2:
        if (this.listenerMap[0] && this.listenerMap[0][type]) {
          listenerList = listenerList.concat(this.listenerMap[0][type]);
        }
        if (this.listenerMap[1] && this.listenerMap[1][type]) {
          listenerList = listenerList.concat(this.listenerMap[1][type]);
        }
        break;
      case 3:
        listenerList = this.listenerMap[0][type];
        break;
    }
    let toFire = [];
    l = listenerList.length;
    while (target && l) {
      for (i = 0; i < l; i++) {
        listener = listenerList[i];
        if (!listener) {
          break;
        }
        if (target.tagName && ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 && target.hasAttribute("disabled")) {
          toFire = [];
        } else if (listener.matcher.call(target, listener.matcherParam, target)) {
          toFire.push([event, target, listener]);
        }
      }
      if (target === root) {
        break;
      }
      l = listenerList.length;
      target = target.parentElement || target.parentNode;
      if (target instanceof HTMLDocument) {
        break;
      }
    }
    let ret;
    for (i = 0; i < toFire.length; i++) {
      if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
        continue;
      }
      returned = this.fire.apply(this, toFire[i]);
      if (returned === false) {
        toFire[i][0][eventIgnore] = true;
        toFire[i][0].preventDefault();
        ret = false;
        break;
      }
    }
    return ret;
  };
  Delegate.prototype.fire = function(event, target, listener) {
    return listener.handler.call(target, event, target);
  };
  function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase();
  }
  function matchesRoot(selector, element) {
    if (this.rootElement === window) {
      return element === document || element === document.documentElement || element === window;
    }
    return this.rootElement === element;
  }
  function matchesId(id, element) {
    return id === element.id;
  }
  Delegate.prototype.destroy = function() {
    this.off();
    this.root();
  };
  var main_default = Delegate;

  // js/custom-element/custom-html-element.js
  var CustomHTMLElement = class extends HTMLElement {
    constructor() {
      super();
      this._hasSectionReloaded = false;
      if (Shopify.designMode) {
        this.rootDelegate.on("shopify:section:select", (event) => {
          const parentSection = this.closest(".shopify-section");
          if (event.target === parentSection && event.detail.load) {
            this._hasSectionReloaded = true;
          }
        });
      }
    }
    get rootDelegate() {
      return this._rootDelegate = this._rootDelegate || new main_default(document.documentElement);
    }
    get delegate() {
      return this._delegate = this._delegate || new main_default(this);
    }
    showLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:start");
    }
    hideLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:end");
    }
    untilVisible(intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }) {
      const onBecameVisible = () => {
        this.classList.add("became-visible");
        this.style.opacity = "1";
      };
      return new Promise((resolve) => {
        if (window.IntersectionObserver) {
          this.intersectionObserver = new IntersectionObserver((event) => {
            if (event[0].isIntersecting) {
              this.intersectionObserver.disconnect();
              requestAnimationFrame(() => {
                resolve();
                onBecameVisible();
              });
            }
          }, intersectionObserverOptions);
          this.intersectionObserver.observe(this);
        } else {
          resolve();
          onBecameVisible();
        }
      });
    }
    disconnectedCallback() {
      var _a;
      this.delegate.destroy();
      this.rootDelegate.destroy();
      (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
      delete this._delegate;
      delete this._rootDelegate;
    }
  };

  var LoyaltyLionCurrentTier = class extends CustomHTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.init();
    }
    init() {
      document.addEventListener('loyalty:customerTierSet', (e) => {
        const {
          detail
        } = (e || {});

        this.setTier(e && detail && detail.currentTier);
      });
    }
    setTier(tier) {
      if (tier) {
        this.innerHTML = tier.name || '';
      }
    }
  };
  window.customElements.define("loyalty-lion-current-tier", LoyaltyLionCurrentTier);

  var LoyaltyLionNextTier = class extends CustomHTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.init();
    }
    init() {
      document.addEventListener('loyalty:customerTierSet', (e) => {
        const {
          detail
        } = (e || {});

        this.setTier(e && detail && detail.currentTier);
      });
    }
    setTier(tier) {
      const HIDDEN_CLASS = 'hidden';
      const HIGHEST_SELECTOR = '[data-rewards="highest-tier-reached"]';
      const TO_NEXT_SELECTOR = '[data-rewards="next-tier-msg"]';
      const nextTier = window.RS.loyaltylion.getNextTier(tier);
      const currentTierName = (tier && tier.name) || '';
      const tierName = (nextTier && nextTier.name) || '';
      let highestElems = document.querySelectorAll(`${HIGHEST_SELECTOR}.${HIDDEN_CLASS}`);
      let toNextTierElems = document.querySelectorAll(`${TO_NEXT_SELECTOR}.${HIDDEN_CLASS}`);
      this.innerHTML = tierName;
      
      if (currentTierName === nextTier.name) {
        highestElems.forEach((elem) => {
          elem.classList.remove(HIDDEN_CLASS);
        });
        toNextTierElems = document.querySelectorAll(`${TO_NEXT_SELECTOR}:not(.${HIDDEN_CLASS})`);
        toNextTierElems.forEach((elem) => {
          elem.classList.add(HIDDEN_CLASS);
        });
      } else {
        toNextTierElems.forEach((elem) => {
          elem.classList.remove(HIDDEN_CLASS);
        });
        highestElems = document.querySelectorAll(`${HIGHEST_SELECTOR}:not(.${HIDDEN_CLASS})`);
        highestElems.forEach((elem) => {
          elem.classList.add(HIDDEN_CLASS);
        });
      }
    }
  };
  window.customElements.define("loyalty-lion-next-tier", LoyaltyLionNextTier);

  var LoyaltyLionToNextTierPoints = class extends CustomHTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.init();
    }
    init() {
      document.addEventListener('loyalty:customerTierSet', (e) => {
        const {
          detail
        } = (e || {});

        this.setTier(e && detail && detail.currentTier);
      });
    }
    setTier(tier) {
      const tierName = (tier && tier.name) || '';
      const nextTier = window.RS.loyaltylion.getNextTier(tier);
      const customer = (window.loyaltylion && window.loyaltylion.customer) || {};
      let points = 0;

      if (tier && customer && nextTier && nextTier.name !== tierName) {
        const lower = (nextTier.bounds && nextTier.bounds.lower) || 0;
        points = lower > customer.pointsApproved
          ? lower - customer.pointsApproved
          : 0;

      }
      this.innerHTML = points;
    }
  };
  window.customElements.define("loyalty-lion-to-next-tier-points", LoyaltyLionToNextTierPoints);

  var LoyaltyLionSocials = class extends CustomHTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.init();
    }
    init() {
      this.delegate.on('click', '[data-action="handleSocial"]', this.handleSocial.bind(this));
      document.addEventListener('loyalty:ready', this.handleLoyaltyReady.bind(this));
    }
    handleLoyaltyReady() {
      this.classList.remove('hidden');
    }
    handleSocial(e) {
      let target = e && e.target;

      if (target) {
        let socialType = target.dataset.social;
        if (!target.dataset.social) {
          target = target.closest('[data-action="handleSocial"]');
          socialType = target ? target.dataset.social : '';
        }
        let link = '';
        const customLinkElem = this.querySelector('[data-lion-referral-url]');
        const customLink = customLinkElem ? customLinkElem.innerHTML : '';
        let text = encodeURIComponent(this.dataset.rewardsReferralMsg || '');

        if(customLink) {
          switch(socialType) {
            case 'facebook':
              link = "https://www.facebook.com/sharer/sharer.php?u=" + customLink
              break;
            case 'twitter':
              link = "https://twitter.com/intent/tweet?text=" + text + customLink
              break;
            case 'email':
              link = "mailto:?body=" + text + customLink
              break;
          }
          if(link) {
            window.open(link, '_blank', {
              noreferrer: 'noopener',
              noopener: true
            });
          }
        }
      }
    }
  };
  window.customElements.define("loyalty-lion-socials", LoyaltyLionSocials);

  (() => {
    window.RS = window.RS || {};
    window.RS.loyaltylion = window.RS.loyaltylion || {};
    window.RS.loyaltylion.tiersSet = false;
    window.RS.loyaltylion.tiers = {};

    window.RS.loyaltylion.getNativeTiers = () => {
      if (window.loyaltylion.program && window.loyaltylion.program.loyaltyTiers) {

      }
      return (window.loyaltylion && window.loyaltylion.program && window.loyaltylion.program.loyaltyTiers) || [];
    };
    window.RS.loyaltylion.getTiers = () => {
      return window.RS && window.RS.loyaltylion && window.RS.loyaltylion.tiers
        ? window.RS.loyaltylion.tiers
        : {}
    };
    window.RS.loyaltylion.setTiers = () => {
      if (window.loyaltylion.program && window.loyaltylion.program.loyaltyTiers) {
        window.RS.loyaltylion.tiers = window.loyaltylion.program.loyaltyTiers.reduce((tiers, tier) => {
          tiers[tier.id] = tier;
          return tiers;
        }, {});
        const tiersObjectSet = new CustomEvent('loyalty:tiersObjectSet',
          {
            detail: {
              tiers: window.RS.loyaltylion.tiers
            }
          }
        );
        document.dispatchEvent(tiersObjectSet);
      }
    };
    window.RS.loyaltylion.getCurrentTier = () => {
      return window.RS && window.RS.loyaltylion && window.RS.loyaltylion.currentCustomerTier
        ? window.RS.loyaltylion.currentCustomerTier
        : '';
    };
    window.RS.loyaltylion.setCustomerCurrentTier = () => {
      if (loyaltylion.customer) {
        const tierId = (loyaltylion.customer.loyaltyTierMembership || {}).loyaltyTierId;
        window.RS.loyaltylion.currentCustomerTier = window.RS.loyaltylion.getTiers()[tierId] || {};
        document.dispatchEvent(new CustomEvent('loyalty:customerReady', {
          detail: {
            customer: loyaltylion.customer
          }
        }));
        document.dispatchEvent(new CustomEvent('loyalty:customerTierSet', {
          detail: {
            currentTier: window.RS.loyaltylion.currentCustomerTier
          }
        }));
      }
    }
    window.RS.loyaltylion.getNextTier = (tier) => {
      let nextTier = {};
      if (tier && (tier.position || tier.position === 0)) {
        const currentPos = tier.position;
        const tiers = window.RS.loyaltylion.getNativeTiers() || [];
        const nextPos = tier.position < (tiers.length - 1)
          ? currentPos + 1
          : currentPos;
        nextTier = tiers[nextPos];
      }
      return nextTier;
    };
    window.RS.loyaltylion.init = () => {
      if (window.loyaltylion) {
        loyaltylion.on('ready', function() {
          document.dispatchEvent(new CustomEvent('loyalty:ready'));
          
          window.RS.loyaltylion.setTiers();

          if (loyaltylion.customer) {
            window.RS.loyaltylion.setCustomerCurrentTier();
          }
        });
      } else {
        console.log("Loyalty Lion not initalized");
      }
    };
    document.addEventListener('loyalty:customerTierSet', (e) => {
      let tier = (e && e.detail && e.detail.currentTier) || {};
      const elems = document.querySelectorAll('[data-rewards="set-current-tier"]');

      if (tier && tier.name) {
        tier = tier.name.toLowerCase();
        document.documentElement.setAttribute('data-current-tier', tier);
        elems.forEach((elem) => {
          elem.classList.add(`rewards-tier--${tier}`, 'rewards-tier--current');
        });
      }
    });

    window.RS.loyaltylion.init();
  })();
})();